import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useParams } from "react-router-dom";
import { Table as TB } from "antd";
import callApi from "../../helpers/callApi";
import USDFigure from "../../Components/USDFigure";
import AreaUnit from "../../Components/AreaUnit";
import TitleHeader from "../accounts/Components/TitleHeader";
import Shops from "./Components/Shops";
import Shopkeepers from "./Components/Shopkeepers";
function BranchDetails(props) {
  const branchId = useParams().branchId;
  const columns = [
    {
      dataIndex: "shop_number",
      title: "Shop #",
    },
    {
      dataIndex: "name",
      title: "Shop Name",
    },
    {
      dataIndex: "floor",
      responsive: ["sm"],
      title: "Floor #",
    },
    {
      dataIndex: "area",
      responsive: ["sm"],
      title: "Shop Area",
    },
    {
      dataIndex: "rental_rate",
      responsive: ["sm"],
      title: "Rental Rate",
    },
    {
      dataIndex: "occupied",
      responsive: ["sm"],
      title: "Occupied",
      filters: [
        {
          text: "Occupied",
          value: "Yes",
        },
        {
          text: "Free Shops",
          value: "No",
        },
      ],
      filterMode: "tree",
      filterSearch: true,
      onFilter: (value, record) => record.occupied.startsWith(value),
    },
  ];
  const shopkeeperColumns = [
    {
      title: "S.no",
      dataIndex: "sno",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Address",
      dataIndex: "address",
      width: "20%",
    },
  ];
  const [shopList, setShopList] = useState([]);
  const [totalNumber, setTotalNumber] = useState({ shops: 0, shopkeepers: 0 });
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [filters, setFilters] = useState();
  const [shopKeeperList, setShopKeeperList] = useState([]);

  let pageSizeValue = 20;
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSizeValue,
      showSizeChanger: true,
      pageSizeOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
    },
  });

  let paging = { current: 1 };
  const handleTableChange = async (pagination, filter, sorter) => {
    pageSizeValue = pagination.pageSize;
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopList([]);
    }
    const params = { size: pagination.pageSize };
    paging.current = pagination.current;
    if (filters) {
      let fils = filters;
      fils.page = pagination.current;
      fils.pageSize = pageSizeValue;
      await fetchData(fils);
    } else {
      await fetchData(params);
    }
  };

  async function fetchData(params = {}) {
    setLoading(true);
    let endpoint = `building-shops/branch-shops/?branchId=${branchId}`;
    const params1 = {
      ...params,
      page: !isFilter ? paging.current - 1 : params.page - 1 || 0,
      size: pageSizeValue || null,
    };
    try {
      const response = await callApi(endpoint, null, null, params1);
      if (response.data && response.status === 200) {
        setShopList(response.data);
        const totalStudents = response.headers.get("x-total-count");
        setTotalNumber({ ...totalNumber, shops: totalStudents });
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: totalStudents,
            current: params1.page + 1,
            pageSize: pageSizeValue,
          },
        });
      } else {
        console.log("Shops error");
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  }

  // const onFilter = async (values) => {
  //   setIsFilter(true);
  //   setTableParams({
  //     ...tableParams,
  //     pagination: {
  //       ...tableParams.pagination,
  //       current: 1,
  //     },
  //   });
  //   let params = {
  //     page: 1,
  //   };
  //   paging.current = 1;
  //   params.institute_enrollment__institute = values.filterInstitute?.value;
  //   params.main_province = values.main_province?.value;

  //   setFilters(params);
  //   localStorage.setItem("shopParams", JSON.stringify(params));
  //   fetchData(params);
  // };

  const getShopKeeperList = async (params = {}) => {
    setLoading(true);
    let endpoint = `shopkeepers/?branchId=${branchId}`;
    const params1 = {
      ...params,
      page: !isFilter ? paging.current - 1 : params.page - 1 || 0,
      size: pageSizeValue || null,
    };
    await callApi(endpoint, null, null, params1)
      .then((response) => {
        setShopKeeperList(response.data);
        const total = response.headers.get("x-total-count");
        setTotalNumber({ ...totalNumber, shopkeepers: total });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    getShopKeeperList();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="container" style={{ marginTop: 100 }}>
        <div class="content">
          <Shops />
          <Shopkeepers />
        </div>
      </div>
    </>
  );
}

export default BranchDetails;
